"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExhibitionListResponseSchema = exports.ExhibitionListItemSchema = exports.ExhibitionListInputScheme = exports.ExhibitionBadgeType = exports.ExhibitionCategoryType = void 0;
var zod_1 = require("zod");
/** 기획전 카테고리 type */
exports.ExhibitionCategoryType = {
    all: 'ALL',
    hotel: 'DOMESTIC_HOTEL',
    motel: 'DOMESTIC_MOTEL',
    pension: 'DOMESTIC_PENSION',
    'guest-house': 'DOMESTIC_GUEST_HOUSE',
    leisure: 'DOMESTIC_LEISURE',
    'global-stay': 'GLOBAL_STAY',
};
/** 기획전 뱃지 type */
exports.ExhibitionBadgeType = {
    NONE: 'NONE',
    ANCORE: 'ANCORE',
    LOWPRICE: 'LOWPRICE',
    DISCOUNT: 'DISCOUNT',
    COUPON: 'COUPON',
    EVENT: 'EVENT',
    MD_RECOMMEND: 'MD_RECOMMEND',
};
exports.ExhibitionListInputScheme = zod_1.z.object({
    page: zod_1.z.number().int().positive().optional(),
    limit: zod_1.z.number().int().positive().optional(),
    exhibitionCategory: zod_1.z.nativeEnum(exports.ExhibitionCategoryType).optional(),
});
exports.ExhibitionListItemSchema = zod_1.z.object({
    id: zod_1.z.string(),
    title: zod_1.z.string(),
    subtitle: zod_1.z.string().nullish(),
    luckId: zod_1.z.string().nullish(),
    representative: zod_1.z.object({
        domain: zod_1.z.string(),
        path: zod_1.z.string(),
        width: zod_1.z.number(),
        height: zod_1.z.number(),
        filename: zod_1.z.string(),
    }),
    badge: zod_1.z.object({
        bgColor: zod_1.z.string(),
        title: zod_1.z.string().nullish(),
        type: zod_1.z.nativeEnum(exports.ExhibitionBadgeType),
    }),
    logMeta: zod_1.z.object({
        deepLinkUri: zod_1.z.string(),
        exhibitionTitle: zod_1.z.string(),
        object: zod_1.z.string(),
        objectType: zod_1.z.string(),
        position: zod_1.z.number(),
    }),
    uiExpMeta: zod_1.z
        .object({
        expElementType: zod_1.z.string(),
        expElementPosition: zod_1.z.number(),
        expElement: zod_1.z.string(),
    })
        .optional(),
});
exports.ExhibitionListResponseSchema = zod_1.z.object({
    data: zod_1.z.array(exports.ExhibitionListItemSchema),
    paging: zod_1.z.object({
        current: zod_1.z.number(),
        isLast: zod_1.z.boolean(),
    }),
});
